import { render, staticRenderFns } from "./replace-ingredient-create.vue?vue&type=template&id=f9efd8e6&"
import script from "./replace-ingredient-create.vue?vue&type=script&lang=js&"
export * from "./replace-ingredient-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports